/* eslint-disable @typescript-eslint/unbound-method */
/* eslint-disable no-param-reassign */
import {
  createEntityAdapter,
  createSlice,
  PayloadAction,
} from '@reduxjs/toolkit';
import { regionThunk } from './region.thunk';
import { RootState } from '../../hooks';
import { CurrentRegion } from './region.interface';

interface InitialStateProps {
  region: CurrentRegion;
  showDialogModal?: boolean;
  errors?: any;
}

const initialState: InitialStateProps = {
  region: {
    country: '',
  },
  showDialogModal: false,
  errors: [],
};

export const regionSlice = createSlice({
  name: 'region',
  initialState,
  reducers: {
    setShowDialog(state, action) {
      state.showDialogModal = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(regionThunk.fulfilled, (state, action) => {
      state.region = action.payload;
    });
    builder.addCase(
      regionThunk.rejected,
      (state, action: PayloadAction<any>) => {
        state.errors.push(action.payload);
      },
    );
  },
});

export const { setShowDialog } = regionSlice.actions;

export const useRegionSelector = (state: RootState): CurrentRegion =>
  state.regionReducer.region;

export const useShowDialogSelector = (state: RootState): string =>
  state.regionReducer.showDialogModal;
